import { RootState } from './state'
import { LogsActions } from '../actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState: RootState.LogsState = {
  rows: [],
  waitingForSearchResults: false,
}

export const logsReducer = createReducer(initialState, (builder) => {
  builder.addCase(LogsActions.launchSearch.fulfilled, (state, action) =>
    action.payload
      ? {
          ...state,
          rows: action.payload.rows || [],
          tags: action.meta.arg.tags,
          descriptor: action.meta.arg.descriptor,
          bookmark: action.payload.paginationBookmark,
          waitingForSearchResults: false,
        }
      : state,
  )
  builder.addCase(LogsActions.launchSearch.pending, (state, action) => ({
    ...state,
    tags: action.meta.arg.tags,
    descriptor: action.meta.arg.descriptor,
    waitingForSearchResults: true,
  }))
  builder.addCase(LogsActions.launchSearch.rejected, (state, action) => ({
    ...state,
    waitingForSearchResults: false,
  }))
  builder.addCase(LogsActions.loadNextPageOfSearchResults.fulfilled, (state, action) =>
    action.payload
      ? {
          ...state,
          rows: (state.rows || []).concat(action.payload.rows || []),
          bookmark: action.payload.paginationBookmark,
          waitingForSearchResults: false,
        }
      : state,
  )
  builder.addCase(LogsActions.loadNextPageOfSearchResults.pending, (state, action) => ({
    ...state,
    waitingForSearchResults: true,
  }))
  builder.addCase(LogsActions.loadNextPageOfSearchResults.rejected, (state, action) => ({
    ...state,
    waitingForSearchResults: false,
  }))
})
